import { type FC } from 'react';
import Lottie, { type Options, type LottieProps } from 'react-lottie';

type LottieAnimationProps = {
  animationData: Options['animationData'];
  options?: Partial<Options>;
} & Omit<LottieProps, 'options'>;

const LottieAnimation: FC<LottieAnimationProps> = ({
  animationData,
  height = 300,
  width = 300,
  options,
  ...props
}) => (
  <Lottie
    height={height}
    width={width}
    options={{
      loop: false,
      autoplay: true,
      ...options,
      animationData,
    }}
    {...props}
  />
);

export default LottieAnimation;
